export default defineNuxtRouteMiddleware(() => {
  const { role } = useCurrentRole()

  if (role.value !== 'owner') {
    return abortNavigation()
  }
})
